import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=1050dd63&scoped=true&"
import script from "./Skeleton.vue?vue&type=script&lang=ts&"
export * from "./Skeleton.vue?vue&type=script&lang=ts&"
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=1050dd63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1050dd63",
  null
  
)

export default component.exports